// import React, { useEffect, useState } from "react";
// import log from "../assets/images/log.png";
// import styles from "./Login.module.css";
// import axios from "axios";
// import qs from "qs";
// import { subscribe_api } from "../Services/api";
// import Cookies from "js-cookie";
// import { v4 as uuidv4 } from "uuid";
// import { ToastContainer, toast } from "react-toastify";

// function Login() {
//   const [number, setNumber] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [ip, setIP] = useState(null);
//   const [userAgent, setUserAgent] = useState(null);

//   const [subLoading, setSubLoading] = useState(false);

//   let token = Cookies.get("token"); // => 'value'

//   useEffect(() => {
//     const fetchIP = async () => {
//       try {
//         const res = await axios.get("https://api.ipify.org?format=json");
//         setIP(res.data.ip);
//       } catch (err) {
//         console.log("Error fetching IP:", err);
//       }
//     };

//     fetchIP();
//   }, []);

//   console.log(ip);

//   const getToken = async () => {
//     const CLIENT_ID = "12fjeqn3lgrpb6m8rmagb2uco4";
//     const CLIENT_SECRET = "h450m9f3kou0pp3l5ig6p3teth7heauuhp2v8gfcrm3546ndq94";
//     const url = `https://third-party.auth.eu-west-1.amazoncognito.com/oauth2/token`;
//     const headers = {
//       "Content-Type": "application/x-www-form-urlencoded",
//       Authorization: "Basic " + btoa(`${CLIENT_ID}:${CLIENT_SECRET}`),
//     };

//     const body = new URLSearchParams({
//       grant_type: "client_credentials",
//     }).toString();

//     console.log({ url: url, headers: headers, body: body });

//     try {
//       const tokenRes = await axios.post(url, body, { headers });
//       console.log(
//         tokenRes,
//         tokenRes.data.access_token,
//         "token ------------------------",
//       );
//       const oneHour = 1 / 24;
//       Cookies.set("token", tokenRes?.data?.access_token, { expires: oneHour });
//       return tokenRes?.data?.access_token;
//     } catch (err) {
//       throw Error;
//     }
//   };

//   console.log(loading);
//   const params = new URLSearchParams(window.location.search);
//   const ext_ref = params.get("ext_ref") || uuidv4();
//   const partner = params.get("partner") || "";

//   useEffect(() => {
//     const user_agent = navigator.userAgent;
//     console.log("User-Agent:", user_agent);
//     setUserAgent(user_agent);
//   }, []);

//   const getHeaders = async () => {
//     // setLoading(true)
//     try {
//       setLoading(true);

//       console.log(token);

//       if (!token) {
//         token = await getToken();
//       }

//       console.log(token);

//       const xhr = new XMLHttpRequest();
//       const url =
//         "https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn";

//       xhr.open("GET", url, true);
//       xhr.setRequestHeader("Content-Type", "application/json");
//       xhr.setRequestHeader("Authorization", `Bearer ${token}`);
//       xhr.setRequestHeader("X-App", "he-partner");
//       xhr.setRequestHeader("X-Source-System", "he-partner");
//       xhr.setRequestHeader("X-MessageID", "1234");

//       console.log(xhr, "xhr--------");

//       xhr.onreadystatechange = function () {
//         if (xhr.readyState === 4) {
//           if (xhr.status === 200) {
//             try {
//               const response = JSON.parse(xhr.responseText);
//               console.log(response, "response...");

//               // Extract the Msisdn value safely
//               const msisdn =
//                 response?.ServiceResponse?.ResponseBody?.Response?.Msisdn ??
//                 null;

//               if (msisdn) {
//                 // Auto sign-in user
//                 console.log(msisdn);
//                 setNumber(msisdn);
//                 setLoading(false);
//               } else {
//                 // setLoading(false);
//               }
//             } catch (error) {
//               console.error("Error parsing response:", error);
//               // setLoading(false);
//             }
//           } else {
//             console.error("Request failed with status:", xhr.status);
//             // setLoading(false);
//           }
//         }
//       };

//       xhr.send();

//       // console.log(res)
//     } catch (err) {
//       console.log(err);
//       // setLoading(false)
//     }
//     // setLoading(false)
//   };

//   console.log(number);

//   useEffect(() => {
//     getHeaders();
//   }, []);

//   const handleSubmit = async (e) => {
//     console.log(number, "number");
//     e.preventDefault();

//     setSubLoading(true);
//     const data = {
//       ani: number,
//       ext_ref: ext_ref,
//       ip_address: ip,
//       user_agent: userAgent,
//     };

//     if (number) {
//       try {
//         // console.log('number-----------',(number))
//         const res = await axios.post(subscribe_api, data);
//         console.log(res.data);
//         if (!res.data.result.cg_url) {
//           setSubLoading(false);
//           toast.error(res?.data?.message);
//           return;
//         }

//         let cgUrl = res.data.result.cg_url;
//         console.log(cgUrl, "url-------------------------");
//         if (cgUrl) {
//           const separator = cgUrl.includes("?") ? "&" : "?";
//           cgUrl = `${cgUrl}${separator}utm_source=${partner || "prop"}`;
//           console.log(cgUrl);

//           window.location.href = cgUrl;
//         }

//         setTimeout(() => {
//           setSubLoading(false);
//         }, 5000);
//       } catch (err) {
//         console.log(number);
//         setTimeout(() => {
//           setSubLoading(false);
//         }, 5000);
//       }
//     }
//   };

//   return (
//     <div className="flex justify-center items-center h-screen bg-black">
//       <h1></h1>
//       <form
//         class="text-neutral-800 py-6 relative overflow-hidden flex flex-col justify-around w-[30rem] px-6 bg-white/5  border border-white/10 rounded-2xl p-5"
//         onSubmit={handleSubmit}
//       >
//         <div class=" flex flex-col items-center before:absolute before:w-32 before:h-20 before:right-2 before:bg-rose-300 before:-z-10 before:rounded-full before:blur-xl before:-top-12 z-10 after:absolute after:w-24 after:h-24 after:bg-orange-300 after:-z-10 after:rounded-full after:blur after:-top-12 after:-right-6">
//           <img src={log} alt="" className="h-[5rem]" />
//           {/* <span class="font-extrabold text-2xl text-violet-600">Get more updates..</span> */}
//           <p class=" text-2xl font-bold text-white text-center">
//             Level up your fun — create your account and start playing!
//           </p>
//           {/* <br/> */}
//         </div>
//         <div class="flex flex-col items-center gap-2">
//           <div className="text-xl font-semibold text-[#f3e739] p-2">
//             Price 15KSH/Daily
//           </div>
//           <button
//             type="submit"
//             className={`${styles.defaultbutton}  w-[16rem]  border-2 border-[#ea7414] text-black ${(!number || subLoading) && "bg-gray-500 border-black"} ${number && "cursor-pointer bg-[#ea7414] text-white"}`}
//             disabled={!number || subLoading}
//           >
//             {!subLoading ? "Subscribe" : "Subscribing...."}
//           </button>
//           {!number && (
//             <p className="text-red-500 text-center">
//               ** Switch To Safaricom Network To Subscribe **
//             </p>
//           )}
//         </div>
//       </form>
//     </div>
//   );
// }

// export default Login;




// import React, { useEffect, useState } from "react";
// import log from "../assets/images/log.png";
// import styles from "./Login.module.css";
// import axios from "axios";
// import { subscribe_api } from "../Services/api";
// import Cookies from "js-cookie";
// import { v4 as uuidv4 } from "uuid";
// import { toast } from "react-toastify";

// function Login() {
//   const [number, setNumber] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [ip, setIP] = useState(null);
//   const [userAgent, setUserAgent] = useState(null);
//   const [subLoading, setSubLoading] = useState(false);

//   let token = Cookies.get("token");

//   useEffect(() => {
//     const user_agent = navigator.userAgent;

//     console.log("User Agent:", user_agent);

//     setUserAgent(user_agent);

//     const fetchIP = async () => {
//       try {
//         const res = await axios.get("https://api.ipify.org?format=json");

//         console.log("IP Address:", res.data.ip);

//         setIP(res.data.ip);
//       } catch (err) {
//         console.log("IP Error:", err);
//       }
//     };

//     fetchIP();
//   }, []);

//   const getToken = async () => {
//     console.log("Getting Cognito Token...");

//     const CLIENT_ID = "12fjeqn3lgrpb6m8rmagb2uco4";

//     const CLIENT_SECRET = "h450m9f3kou0pp3l5ig6p3teth7heauuhp2v8gfcrm3546ndq94";

//     const url =
//       "https://third-party.auth.eu-west-1.amazoncognito.com/oauth2/token";

//     const headers = {
//       "Content-Type": "application/x-www-form-urlencoded",

//       Authorization: "Basic " + btoa(`${CLIENT_ID}:${CLIENT_SECRET}`),
//     };

//     const body = new URLSearchParams({
//       grant_type: "client_credentials",
//     }).toString();

//     try {
//       const tokenRes = await axios.post(url, body, {
//         headers,
//       });

//       console.log("Token Response:", tokenRes.data);

//       Cookies.set("token", tokenRes.data.access_token, {
//         expires: 1 / 24,
//       });

//       return tokenRes.data.access_token;
//     } catch (err) {
//       console.log("Token Error:", err);
//     }
//   };

//   const getHeaders = async () => {
//     try {
//       setLoading(true);

//       console.log("Existing Token:", token);

//       if (!token) {
//         token = await getToken();
//       }

//       console.log("Using Token:", token);

//       const xhr = new XMLHttpRequest();

//       const url =
//         "https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn";

//       xhr.open("GET", url, true);

//       xhr.setRequestHeader("Content-Type", "application/json");

//       xhr.setRequestHeader("Authorization", `Bearer ${token}`);

//       xhr.setRequestHeader("X-App", "he-partner");

//       xhr.setRequestHeader("X-Source-System", "he-partner");

//       xhr.setRequestHeader("X-MessageID", "1234");

//       console.log("Calling MSISDN API...");

//       xhr.onreadystatechange = () => {
//         if (xhr.readyState === 4) {
//           console.log("MSISDN API Status:", xhr.status);

//           if (xhr.status === 200) {
//             try {
//               const response = JSON.parse(xhr.responseText);

//               console.log("MSISDN Response:", response);

//               const msisdn =
//                 response?.ServiceResponse?.ResponseBody?.Response?.Msisdn;

//               console.log("MSISDN:", msisdn);

//               if (msisdn) {
//                 setNumber(msisdn);
//               }
//             } catch (err) {
//               console.log("JSON Parse Error:", err);
//             }
//           } else {
//             console.log("MSISDN API Failed");
//           }

//           setLoading(false);
//         }
//       };

//       xhr.send();
//     } catch (err) {
//       console.log("Header Error:", err);

//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getHeaders();
//   }, []);

//   const submitHandler = (e) => {
//     e.preventDefault();

//     console.log("Subscribe Button Clicked");

//     console.log("Current MSISDN:", number);

//     console.log("IP:", ip);

//     console.log("User Agent:", userAgent);

//     const url = "https://dsdp-cg.safaricom.com/consent-gateway/001048837598";
    

//     console.log("Opening URL:", url);

//     window.open(url, "_blank");
//   };

//   return (
//     <div className="flex justify-center items-center h-screen bg-black">
//       <form
//         className="text-neutral-800 py-6 relative overflow-hidden flex flex-col justify-around w-[30rem] px-6 bg-white/5 border border-white/10 rounded-2xl p-5"
//         onSubmit={submitHandler}
//       >
//         <div className="flex flex-col items-center">
//           <img src={log} alt="" className="h-[5rem]" />

//           <p className="text-2xl font-bold text-white text-center">
//             Level up your fun — create your account and start playing!
//           </p>
//         </div>

//         <div className="flex flex-col items-center gap-2">
//           <div className="text-xl font-semibold text-[#f3e739] p-2">
//             Price 15KSH/Daily
//           </div>

//           <button
//             type="submit"
//             className={`${styles.defaultbutton} w-[16rem] border-2 border-[#ea7414] text-white`}
//           >
//             Subscribe
//           </button>

//           {!number && (
//             <p className="text-red-500 text-center">
//               ** Switch To Safaricom Network To Subscribe **
//             </p>
//           )}
//         </div>
//       </form>
//     </div>
//   );
// }

// export default Login;




import React, { useEffect, useState } from "react";
import log from "../assets/images/log.png";
import styles from "./Login.module.css";
import axios from "axios";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";

function Login() {
  const [number, setNumber] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ip, setIP] = useState(null);
  const [userAgent, setUserAgent] = useState(null);
  const [subLoading, setSubLoading] = useState(false);

  let token = Cookies.get("token");

  // Get ext_ref from URL.
  // If ext_ref is not present, generate a new one.
  const params = new URLSearchParams(window.location.search);

  const ext_ref = params.get("ext_ref") || uuidv4();

  // Get partner if it is passed in the URL
  const partner = params.get("partner") || "";

  console.log("EXT_REF:", ext_ref);
  console.log("PARTNER:", partner);

  useEffect(() => {
    const user_agent = navigator.userAgent;

    console.log("User Agent:", user_agent);

    setUserAgent(user_agent);

    const fetchIP = async () => {
      try {
        const res = await axios.get(
          "https://api.ipify.org?format=json"
        );

        console.log("IP Address:", res.data.ip);

        setIP(res.data.ip);
      } catch (err) {
        console.log("IP Error:", err);
      }
    };

    fetchIP();
  }, []);

  const getToken = async () => {
    console.log("Getting Cognito Token...");

    const CLIENT_ID = "12fjeqn3lgrpb6m8rmagb2uco4";

    const CLIENT_SECRET =
      "h450m9f3kou0pp3l5ig6p3teth7heauuhp2v8gfcrm3546ndq94";

    const url =
      "https://third-party.auth.eu-west-1.amazoncognito.com/oauth2/token";

    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization:
        "Basic " + btoa(`${CLIENT_ID}:${CLIENT_SECRET}`),
    };

    const body = new URLSearchParams({
      grant_type: "client_credentials",
    }).toString();

    try {
      const tokenRes = await axios.post(url, body, {
        headers,
      });

      console.log("Token Response:", tokenRes.data);

      Cookies.set("token", tokenRes.data.access_token, {
        expires: 1 / 24,
      });

      return tokenRes.data.access_token;
    } catch (err) {
      console.log("Token Error:", err);
    }
  };

  const getHeaders = async () => {
    try {
      setLoading(true);

      console.log("Existing Token:", token);

      if (!token) {
        token = await getToken();
      }

      console.log("Using Token:", token);

      const xhr = new XMLHttpRequest();

      const url =
        "https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn";

      xhr.open("GET", url, true);

      xhr.setRequestHeader(
        "Content-Type",
        "application/json"
      );

      xhr.setRequestHeader(
        "Authorization",
        `Bearer ${token}`
      );

      xhr.setRequestHeader("X-App", "he-partner");

      xhr.setRequestHeader(
        "X-Source-System",
        "he-partner"
      );

      xhr.setRequestHeader("X-MessageID", "1234");

      console.log("Calling MSISDN API...");

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          console.log(
            "MSISDN API Status:",
            xhr.status
          );

          if (xhr.status === 200) {
            try {
              const response = JSON.parse(
                xhr.responseText
              );

              console.log(
                "MSISDN Response:",
                response
              );

              const msisdn =
                response?.ServiceResponse
                  ?.ResponseBody
                  ?.Response?.Msisdn;

              console.log("MSISDN:", msisdn);

              if (msisdn) {
                setNumber(msisdn);
              }
            } catch (err) {
              console.log(
                "JSON Parse Error:",
                err
              );
            }
          } else {
            console.log(
              "MSISDN API Failed"
            );
          }

          setLoading(false);
        }
      };

      xhr.send();
    } catch (err) {
      console.log("Header Error:", err);

      setLoading(false);
    }
  };

  useEffect(() => {
    getHeaders();
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();

    console.log(
      "Subscribe Button Clicked"
    );

    console.log(
      "Current MSISDN:",
      number
    );

    console.log("IP:", ip);

    console.log(
      "User Agent:",
      userAgent
    );

    console.log(
      "Using EXT_REF:",
      ext_ref
    );

    // Build query parameters
    const queryParams = new URLSearchParams();

    // IMPORTANT:
    // Pass the same ext_ref to Safaricom
    queryParams.append(
      "ext_ref",
      ext_ref
    );

    // Pass partner only if available
    if (partner) {
      queryParams.append(
        "partner",
        partner
      );
    }

    const url =
      `https://dsdp-cg.safaricom.com/consent-gateway/001048837598?${queryParams.toString()}`;

    console.log(
      "Opening URL:",
      url
    );

    setSubLoading(true);

    // Open Safaricom consent page
    window.open(
      url,
      "_blank"
    );
  };

  return (
    <div className="flex justify-center items-center h-screen bg-black">
      <form
        className="text-neutral-800 py-6 relative overflow-hidden flex flex-col justify-around w-[30rem] px-6 bg-white/5 border border-white/10 rounded-2xl p-5"
        onSubmit={submitHandler}
      >
        <div className="flex flex-col items-center">
          <img
            src={log}
            alt=""
            className="h-[5rem]"
          />

          <p className="text-2xl font-bold text-white text-center">
            Level up your fun — create your account and start playing!
          </p>
        </div>

        <div className="flex flex-col items-center gap-2">
          <div className="text-xl font-semibold text-[#f3e739] p-2">
            Price 15KSH/Daily
          </div>

          <button
            type="submit"
            disabled={subLoading}
            className={`${styles.defaultbutton} w-[16rem] border-2 border-[#ea7414] text-white`}
          >
            {subLoading
              ? "Redirecting..."
              : "Subscribe"}
          </button>

          {!number && (
            <p className="text-red-500 text-center">
              ** Switch To Safaricom Network To Subscribe **
            </p>
          )}
        </div>
      </form>
    </div>
  );
}

export default Login;